import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
export const Header = ()=> {
    const [scroll, setScroll] = useState(false);
    const [toggleBar, setToggleBar] = useState(false);

    const toggleHandler = () => {
        setToggleBar(true);
    }
    const UnSetToggle = () => {
        setToggleBar(!toggleBar)

    }
    useEffect(()=> {
        scrollFixed();
        
    },[] )

    function scrollFixed() {
        window.addEventListener('scroll', function(){
            var hHeader = this.document.querySelector('#header .container1636').offsetHeight;
            setScroll(window.scrollY > hHeader);
            
        })
    }
    
    return (
        <div id="header">
            <div className={`container-fluid${ scroll ? ' shrink-container-fluid' : '' }`}>
                <div className="container container1636">
                    <nav className="nav-header">
                        <div className="boxLeft">
                            <div className="hamburger" id="hamburger-menu" onClick={() => toggleHandler()} style={{ display: toggleBar ? 'none' : ''}}>
                                <div className="bar1"></div>
                                <div className="bar2"></div>
                                <div className="bar3"></div>
                            </div>
                            <div className={`logo${ scroll ? ' shrink-logo' : ''}`}>
                                <Link to="/"><img src={require('../images/logos.png')} alt="logos"/></Link>
                            </div>
                        </div>
                        <div className="main-menu">
                            <ul className="media-menu">
                                <li>
                                    <Link><img src={require('../images/facebook-1.png')} alt="facebook-icon"/></Link>
                                </li>
                                <li>
                                    <Link><img src={require('../images/youtube-1.png')} alt="facebook-icon"/></Link>
                                </li>
                            </ul>
                            <div className="main-top-menu" style={{display: scroll ? 'none' : ''}}>
                                <div className="main-menu-container">
                                    <ul id="mainMenu" className="menu">
                                        <li><Link to="/sd">Careers</Link></li>
                                        <li><Link to="/sd">Faqs</Link></li>
                                    </ul>
                                </div>
                                <ul className="visit-media-menu">
                                    <span>Visit Us:</span>
                                    <li>
                                        <Link><img src={require('../images/facebook-1.png')} alt="facebook-icon"/></Link>
                                    </li>
                                    <li>
                                        <Link><img src={require('../images/youtube-1.png')} alt="facebook-icon"/></Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="main-nav">
                                <div className="main-nav-container">
                                    <ul id="main-nav-menu" className="menu">
                                        <li><Link>Tire TBR</Link></li>
                                        <li><Link>Tire PCR</Link></li>
                                        <li><Link>WHEEL</Link></li>
                                        <li><Link>Lub Auto</Link></li>
                                        <li><Link>Lub Motorycle</Link></li>
                                        <li><Link>Media</Link></li>
                                        <li><Link>About</Link></li>
                                        <li><Link>Contact</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>  
                    </nav>
                    {/* -------Hamburger Menu-------- */}
                    <div className="center-menu-tablet" style={{ display: !toggleBar ? 'none' : 'flex'}}>
                        <div id="hamburger-menu-cls" className="hamburger change-hamburger-menu" onClick={() => UnSetToggle()} >
                            <div className="bar1"></div>
                            <div className="bar2"></div>
                            <div className="bar3"></div>
                        </div>
                        <div>
                            <div className="menu-mainmenu-container">
                                <ul className="menu" id="main-menu-1">
                                    <li className="animate__animated animate__bounceInLeft delay-01 animate__duration-1.5s">
                                        <Link>
                                            Tire TBR
                                        </Link>
                                    </li>
                                    <li className="animate__animated animate__bounceInLeft delay-02 animate__duration-1.5s">
                                        <Link>
                                            Tire PCR
                                        </Link>
                                    </li>
                                    <li className="animate__animated animate__bounceInLeft delay-03 animate__duration-1.5s">
                                        <Link>
                                            Wheel
                                        </Link>
                                    </li>
                                    <li className="animate__animated animate__bounceInLeft delay-04 animate__duration-1.5s">
                                        <Link>
                                            Lub Auto
                                        </Link>
                                    </li>
                                    <li className="animate__animated animate__bounceInLeft delay-05 animate__duration-1.5s">
                                        <Link>
                                            Lub Motorycle
                                        </Link>
                                    </li>
                                    <li className="animate__animated animate__bounceInLeft delay-06 animate__duration-1.5s">
                                        <Link>
                                            Media
                                        </Link>
                                    </li>
                                    <li className="animate__animated animate__bounceInLeft delay-07 animate__duration-1.5s">
                                        <Link>
                                            About
                                        </Link>
                                    </li>
                                    <li className="animate__animated animate__bounceInLeft delay-08 animate__duration-1.5s">
                                        <Link>
                                            Contact
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="main_menus">
                                <div className="menu-topmenu-container">
                                    <ul id="menu-topmenu-1" className="menu"><li className="animate__animated animate__bounceInLeft animate__duration-1.5s delay-09"><Link to="https://gmi68international.com/careers/">Careers</Link></li>
                                        <li className="animate__animated animate__bounceInLeft animate__duration-1.5s delay-010"><Link to="https://gmi68international.com/faqs/">Faqs</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}